import styled, { css } from 'styled-components'

interface IModalWrapperProps {
  maxwidth: number
  maxheight: number
  isconfirmation: string
  isInfo: string
  isApproved: string
  $roboto?: boolean
}

export const ModalWrapper = styled.div<IModalWrapperProps>`
  .ant-modal {
    max-width: ${(props) => props.maxwidth}px;
    width: 100% !important;
    padding: 10px;
  }
  .ant-modal-content {
    border-radius: 16px;
  }
  .ant-modal-header {
    border-radius: 16px 16px 0 0;
    padding-left: 20px;
    padding-right: 20px;
    border-bottom: none;
    ${({ isInfo }) =>
      isInfo === 'true' &&
      css`
        background-color: #e7f3fe;
      `};
    ${({ isconfirmation }) =>
      isconfirmation === 'true' &&
      css`
        background-color: #fff2c7;
      `}
    ${({ isApproved }) =>
      isApproved === 'true' &&
      css`
        background-color: #d7f5e9;
      `};
    ${({ isApproved }) =>
      isApproved === 'false' &&
      css`
        background-color: #fde0e0;
      `};
  }
  .ant-modal-title {
    font-size: 16px !important;
    color: #213f68;
    font-weight: 700;
    svg {
      margin-right: 8px;
    }
  }
  .rankmi-modal-title-row {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .rankmi-modal-back-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    border-radius: 8px;
    background: #f0f0f0;
    color: #4c4c4c;
    cursor: pointer;
    flex-shrink: 0;
    line-height: 0;
    transition: color 0.2s ease-in-out;
    svg {
      margin: 0 !important;
      display: block;
    }
    &:hover {
      background: #f0f0f0;
      color: rgba(76, 76, 76, 0.7);
    }
    &:focus,
    &:active {
      background: #f0f0f0;
      color: #4c4c4c;
      outline: none;
    }
  }
  .ant-modal-body {
    padding: 0 20px;
    ${(props) =>
      props.isconfirmation === 'true' &&
      css`
        padding-top: 20px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        word-break: break-word;
      `}
    max-height: ${(props) => props.maxheight}px;
    overflow-y: auto;
    color: #202020;
    font-size: 16px;
  }
  .ant-modal-footer {
    padding: 20px;
    border-top: none;
  }
  .ant-row {
    margin-top: -16px !important;
    margin-bottom: -29px !important;
  }
  .ant-modal-mask,
  .ant-modal-wrap {
    z-index: 1020;
  }
  ${({ $roboto }) =>
    $roboto &&
    css`
      .ant-modal-title,
      .ant-modal-body {
        font-family: Roboto, sans-serif;
      }
    `}
`
